'use client';

import { Popover as PopoverPrimitive } from 'radix-ui';
import * as React from 'react';

import { cn } from '../../lib/utils';
import { menuStyles } from '../lib/menu-styles';

/**
 * shadcn Popover (Radix). `surface="menu"` (default) is the Figma Menu surface
 * (MultiSelect, Combobox, pickers); `surface="panel"` is the Figma Popover
 * (lib/popover.tsx): no padding, header / body / footer sections.
 */
function Popover(props: React.ComponentProps<typeof PopoverPrimitive.Root>) {
  return <PopoverPrimitive.Root data-slot="popover" {...props} />;
}

function PopoverTrigger(props: React.ComponentProps<typeof PopoverPrimitive.Trigger>) {
  return <PopoverPrimitive.Trigger data-slot="popover-trigger" {...props} />;
}

/** Positions the content against an element other than the trigger (Combobox box). */
function PopoverAnchor(props: React.ComponentProps<typeof PopoverPrimitive.Anchor>) {
  return <PopoverPrimitive.Anchor data-slot="popover-anchor" {...props} />;
}

function PopoverClose(props: React.ComponentProps<typeof PopoverPrimitive.Close>) {
  return <PopoverPrimitive.Close data-slot="popover-close" {...props} />;
}

function PopoverContent({
  className,
  align = 'start',
  sideOffset = 4,
  surface = 'menu',
  ...props
}: React.ComponentProps<typeof PopoverPrimitive.Content> & {
  surface?: 'menu' | 'panel';
}) {
  return (
    <PopoverPrimitive.Portal>
      <PopoverPrimitive.Content
        data-slot="popover-content"
        align={align}
        sideOffset={sideOffset}
        className={
          surface === 'panel'
            ? cn(className)
            : menuStyles().content({
                className: cn(
                  'origin-(--radix-popover-content-transform-origin)',
                  className,
                ),
              })
        }
        {...props}
      />
    </PopoverPrimitive.Portal>
  );
}

export { Popover, PopoverAnchor, PopoverClose, PopoverContent, PopoverTrigger };
